import clsx from "clsx";

import { getConfig } from "lib/get-config";
import { useTranslation } from "lib/i18n/use-translation";
import { getPersonName } from "lib/toc/person-name";
import { useToc } from "lib/toc/use-toc";
import { getBackUrl } from "lib/urls/back";

import ChevronLeftIcon from "assets/icons/chevron-left.svg?react";
import css from "./title.module.scss";

export function Title() {
  const { t } = useTranslation();
  const { toc } = useToc();
  const { trials } = getConfig();

  const skipTranslation = toc?.Meta?.Lang === document.documentElement.lang;
  const author = toc?.Meta.Authors?.find(a => a.Role === "author");
  const fullName = author ? getPersonName(author) : t("Неизвестный автор");
  const bookTitle = toc?.Meta.Title || t("Без названия");

  const isFragment = trials === 1;

  const backUrl = getBackUrl();

  return (
    <div className={clsx(css.root, isFragment && css.fragment)}>
      <a
        className={css.titleLink}
        href={backUrl}
        translate={skipTranslation ? "no" : undefined}
      >
        <ChevronLeftIcon className={css.arrow} />
        {isFragment ? (
          <>
            <span className={css.bookTitle} data-testid="bookTitle">
              {bookTitle}
            </span>
            <span className={css.author}>{fullName}</span>
            <span className={css.fragmentBadge} data-testid="fragmentBadge">
              {t("Фрагмент")}
            </span>
          </>
        ) : (
          <span className={css.title} data-testid="bookTitle">
            {fullName} &laquo;{bookTitle}&raquo;
          </span>
        )}
      </a>
    </div>
  );
}
